import * as React from "react";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import {
  getAppleWalletError,
  getAppleWalletResponse,
  getIsLoadingAppleWallet,
} from "../../reducers/methods";
import { WIDGET_URL } from "../../config";

import "./AppleWallet.css";

export interface AppleWalletComponentProps extends ComponentBaseProps {
  appleWalletReferral: ReturnType<typeof getAppleWalletResponse>;
  isLoading: ReturnType<typeof getIsLoadingAppleWallet>;
  error: ReturnType<typeof getAppleWalletError>;
  style: { [styleProp: string]: string };
  classNames: string;
  label: string;
}

export class AppleWallet extends ComponentBase<AppleWalletComponentProps> {
  constructor(props: AppleWalletComponentProps) {
    super(props);
  }

  render() {
    const link = this.props.appleWalletReferral.link;
    // Fall back to a data link for backwards compatibility purposes.
    // Remove the fallback after the backend update to serve the file from s3 is deployed.
    // See https://developer.apple.com/documentation/walletpasses/distributing-and-updating-a-pass#Create-a-bundle-of-passes
    // for details on the MIME type.

    const passLink = link
      ? link.startsWith("https://")
        ? link
        : `data:application/vnd.apple.pkpass;base64,${link}`
      : "";

    return (
      <div
        style={this.props.style}
        className={`apple-wallet ${this.props.classNames}`}
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        ref={(component) => (this.component = component)}
      >
        <a
          href={passLink}
          className={`apple-wallet__button ${
            this.props.isLoading || this.props.error
              ? "apple-wallet__button--disabled"
              : ""
          }`}
          download="passbook.pkpass"
          aria-label={this.props.label}
        >
          <img
            src={`${WIDGET_URL}add_to_apple_wallet_button.svg`}
            alt="Add to Apple Wallet"
            className="apple-wallet__button__image"
          />
        </a>
      </div>
    );
  }
}
